export const PROMPT_ID = '45934349-c493-42a3-87c6-d3753bab715c';
export const FALLBACK_KIT_ID = 'modest';
